import {
  ADDPRODUCT,
  DECREASEPRODUCT,
  INCREASEPRODUCT,
  INCREASEPRODUCTBYVALUE,
} from './actionTypes';

export const addProduct = (product) => {
  return {
    type: ADDPRODUCT,
    payload: product,
  };
};

export const increaseProduct = (id) => {
  return {
    type: INCREASEPRODUCT,
    payload: id,
  };
};

export const decreaseProduct = (id) => {
  return {
    type: DECREASEPRODUCT,
    payload: id,
  };
};

export const increaseProductByValue = (id, value) => {
  return {
    type: INCREASEPRODUCTBYVALUE,
    payload: { id, value },
  };
};
